import { useEffect } from "react";
import { track } from "@/lib/analytics";
import { useContent } from "@/context/ContentContext";

export const Analytics = () => {
  const { content } = useContent();
  const ga = content.brand?.ga4Id;

  useEffect(() => {
    const start = Date.now();
    track("pageview");
    const onClick = (e) => {
      const el = e.target.closest("[data-track]");
      if (el) track("click", { label: el.getAttribute("data-track") });
    };
    const onLeave = () => track("time", { duration: Math.round((Date.now() - start) / 1000) });
    document.addEventListener("click", onClick);
    window.addEventListener("beforeunload", onLeave);
    return () => { document.removeEventListener("click", onClick); window.removeEventListener("beforeunload", onLeave); onLeave(); };
  }, []);

  useEffect(() => {
    if (!ga || document.getElementById("ga4-src")) return;
    const s = document.createElement("script");
    s.id = "ga4-src"; s.async = true; s.src = `https://www.googletagmanager.com/gtag/js?id=${ga}`;
    document.head.appendChild(s);
    const s2 = document.createElement("script");
    s2.id = "ga4-init";
    s2.innerHTML = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${ga}');`;
    document.head.appendChild(s2);
  }, [ga]);

  return null;
};
